/* eslint-disable no-mixed-spaces-and-tabs */
import React from "react";
import PropTypes from "prop-types";
import Cases from "./CareManagerColumnsComponents/Cases";
import NoCases from "../../../../containers/Home/Pages/CareManagerColumn/NoCases";

const CareManagerColumn = ({
																											idExt,
																											isSouscription,
																											redirectToOnboarding,
																											setShowOfferModal,
																											setDisplayQuestions,
																											casesRedirection,
																											handleOpenNavItem
																											}) => {
return (
<div className={"careManagerColumn"}>
{casesRedirection ? (
<Cases
idExt={idExt}
isSouscription={isSouscription}
redirectToOnboarding={redirectToOnboarding}
setShowOfferModal={setShowOfferModal}
setDisplayQuestions={setDisplayQuestions}
handleOpenNavItem={handleOpenNavItem}
/>
) : (
<NoCases
idExt={idExt}
isSouscription={isSouscription}
redirectToOnboarding={redirectToOnboarding}
setShowOfferModal={setShowOfferModal}
setDisplayQuestions={setDisplayQuestions}
handleOpenNavItem={handleOpenNavItem}
/>
)}
</div>
);
};

CareManagerColumn.propTypes = {
redirectToOnboarding: PropTypes.func,
idExt: PropTypes.string,
isSouscription: PropTypes.func,
setShowOfferModal: PropTypes.func,
setDisplayQuestions: PropTypes.func,
casesRedirection: PropTypes.bool,
handleOpenNavItem: PropTypes.func
};

export default CareManagerColumn;
